export const getActions = (set) => ({
    updateState: state => {
        set(state);
    },
});
